"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
var _locales = require("../../utils/locales");
const messages = exports.messages = {
  [_locales.locales.en]: {
    toggle: "Click to toggle list"
  },
  [_locales.locales.es]: {
    toggle: "Haga clic para alternar la lista"
  },
  [_locales.locales.fr]: {
    toggle: "Cliquez pour basculer la liste"
  },
  [_locales.locales.pt]: {
    toggle: "Clique para alternar a lista"
  },
  [_locales.locales.zh]: {
    toggle: "點擊以切換列表"
  },
  [_locales.locales.de]: {
    toggle: "Klicken Sie, um die Liste umzuschalten"
  },
  [_locales.locales.it]: {
    toggle: "Fare clic per alternare l'elenco"
  },
  [_locales.locales.ja]: {
    toggle: "リストを切り替えるにはクリックしてください"
  },
  [_locales.locales.tl]: {
    toggle: "I-click upang i-toggle ang listahan"
  },
  [_locales.locales.hi]: {
    toggle: "सूची को टॉगल करने के लिए क्लिक करें"
  },
  [_locales.locales.ko]: {
    toggle: "목록을 전환하려면 클릭하세요"
  }
};